'use strict';

var integrations = require('integrations/productDetail');
integrations.baseFiles.detail = require('./product/detail');

module.exports = integrations;
